<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M0.545898 9.99994L10.3751 0.170776H13.8459L5.38757 8.59995H23.2667V11.3999H5.38757L13.8459 19.8291H10.3751L0.545898 9.99994Z"
    fill="#150E0B"
  />
</svg>
